import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PatientWorkflowApiEffects } from './patient-workflow-api/patient-workflow-api.effects';
import { PatientWorkflowWsEffects } from './patient-workflow-ws/patient-workflow-ws.effects';
import * as fromPatientWorkflow from './patient-workflow/patient-workflow.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('patientWorkflow', fromPatientWorkflow.reducer),
    EffectsModule.forFeature([PatientWorkflowApiEffects, PatientWorkflowWsEffects]),
  ],
})
export class SharedPatientWorkflowDataAccessModule {}
